export const PROPERTY_VIEW_PAGE_KEY = 'property-view';
